var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"26","height":"6","viewBox":"0 0 26 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"3","cy":"3","r":"3","fill":"black"}}),_c('circle',{attrs:{"cx":"13","cy":"3","r":"3","fill":"black"}}),_c('circle',{attrs:{"cx":"23","cy":"3","r":"3","fill":"black"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }